import { render, staticRenderFns } from "./CustomersSlimList.vue?vue&type=template&id=255118cf&"
import script from "./CustomersSlimList.vue?vue&type=script&lang=js&"
export * from "./CustomersSlimList.vue?vue&type=script&lang=js&"
import style0 from "./CustomersSlimList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports